import { render, staticRenderFns } from "./sideMenu.vue?vue&type=template&id=9dccb21c&"
import script from "./sideMenu.vue?vue&type=script&lang=js&"
export * from "./sideMenu.vue?vue&type=script&lang=js&"
import style0 from "./sideMenu.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports